import { formatFiltersLegend } from '@/utils/filterUtils'
import { computed, type ComputedRef, type MaybeRefOrGetter, toValue } from 'vue'
import { useI18n } from 'vue-i18n'

export function useFiltersLegend(
  activeCount: MaybeRefOrGetter<number>,
  labelKey = 'common.filters'
): ComputedRef<string> {
  const { t } = useI18n()
  return computed(() => formatFiltersLegend(t(labelKey), toValue(activeCount)))
}
